import { render, staticRenderFns } from "./Profilo.vue?vue&type=template&id=4108619c&scoped=true&"
import script from "./Profilo.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Profilo.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Profilo.vue?vue&type=style&index=0&id=4108619c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108619c",
  null
  
)

export default component.exports